import { Redirect, useLocation, useParams } from 'react-router-dom';

import { PRE_ORDER_GENETICS_BASE_PATH } from './paths';

type GeneticsEligibilityRedirectProps = {
  company: string;
};
/**
 * Redirects to the new path for genetics eligibility verification.
 * Note: Track removal of this component and the underlying code in PC-1557.
 * @param companyProp - The company to use for the redirect.
 * @constructor
 */
export const GeneticsEligibilityRedirect: React.FC<GeneticsEligibilityRedirectProps> = ({
  company: companyProp,
}) => {
  const { company: companyFromPath } = useParams<{ company?: string }>();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const companyFromQuery = queryParams.get('company');

  // Determine the company value to use
  const company = companyProp || companyFromPath || companyFromQuery;

  // Redirect to the new path with the same company parameter
  return <Redirect to={`${PRE_ORDER_GENETICS_BASE_PATH}/${company}`} />;
};
